import { Helmet } from 'react-helmet-async';
import ServicePage from './ServicePage';
import { useService } from '../hooks/usePublicApi';
import { serviceCategories } from '../data/services';

const staticData = serviceCategories.find((s) => s.id === 'neubau');

export default function Neubau() {
  const { service } = useService('neubau');
  const data = service || staticData;

  return (
    <>
      <Helmet>
        <title>Neubau — Innenausbau | Süd Ausbau GmbH</title>
        <meta name="description" content="Kompletter Innenausbau für Neubauprojekte in München. Von der Rohbauphase bis zum schlüsselfertigen Ergebnis — Süd Ausbau GmbH." />
      </Helmet>
      <ServicePage data={data} />
    </>
  );
}
